import { ActionIcon, Tooltip } from "@mantine/core";
import { FileCsvIcon } from "@phosphor-icons/react";
import { ComponentProps, useId } from "react";
import { CSVLink } from "react-csv";

import { ACTION_ICON_PROPS, ICON_PROPS } from "./ExportBtn.constants";

type ExportColumn<T> =
  | {
      key: keyof T;
      headerName: string;
      getValue?: (row: T) => string | number;
    }
  | {
      key: "CUSTOM";
      headerName: string;
      getValue: (row: T) => string | number;
    };

type ExportBtnCSVProps<T> = {
  data: T[];
  columnsV2: ExportColumn<T>[];
  title: string;
  actionIconProps?: ComponentProps<typeof ActionIcon>;
  tooltipProps?: ComponentProps<typeof Tooltip>;
};

export function ExportBtnCSV<T>({ data, columnsV2, title, actionIconProps, tooltipProps }: ExportBtnCSVProps<T>) {
  const resolvedColumns = columnsV2.filter((column) => Boolean(column.headerName));
  const btnId = useId().replaceAll(":", "");

  const headers = resolvedColumns.map((column, index) => ({
    label: column.headerName,
    key: `col_${index}`
  }));

  const csvData = data.map((row) =>
    Object.fromEntries(
      resolvedColumns.map((column, index) => {
        let value: unknown;

        if (column.key === "CUSTOM") {
          value = column.getValue?.(row);
        } else if (column.getValue) {
          value = column.getValue(row);
        } else {
          value = row[column.key];
        }

        return [`col_${index}`, value == null ? "" : String(value)];
      })
    )
  );

  return (
    <>
      <Tooltip label="Exportar CSV" color="green" {...tooltipProps} target={`#${btnId}`} />
      <ActionIcon
        filename={`${title}.csv`}
        {...ACTION_ICON_PROPS}
        enclosingCharacter=""
        {...actionIconProps}
        component={CSVLink}
        headers={headers}
        data={csvData}
        separator=";"
        color="green"
        id={btnId}
      >
        <FileCsvIcon {...ICON_PROPS} />
      </ActionIcon>
    </>
  );
}
